<template>
  <div class="card-content">
    <div class="columns is-multiline is-variable is-1-mobile">
      <!-- Campo Placa -->
      <div class="column is-full-mobile is-one-quarter-desktop">
        <div class="field">
          <label class="label">Placa</label>
          <div class="control">
            <b-input
              v-model="filtro.placa"
              icon="card-bulleted-outline"
              placeholder="Digite a placa"
              name="placa"
              class="is-fullwidth"
              @input="buscar"
            />
          </div>
        </div>
      </div>

      <!-- Select Documento fiscal -->
      <div class="column is-full-mobile is-one-quarter-desktop">
        <div class="field">
          <label class="label">Tipo</label>
          <div class="control">
            <b-select v-model="filtro.tipo" expanded @input="buscar">
              <option :value="null">-</option>
              <option value="GRAO">Grão</option>
              <option value="TANQUE">Tanque</option>
            </b-select>
          </div>
        </div>
      </div>

      <!-- Select Documento fiscal -->
      <div class="column is-full-mobile is-one-quarter-desktop">
        <div class="field">
          <label class="label">Documento anexado?</label>
          <div class="control">
            <b-select
              v-model="filtro.temDocumentoFiscal"
              expanded
              @input="buscar"
            >
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </b-select>
          </div>
        </div>
      </div>

      <!-- Select Destino -->
      <div class="column is-full-mobile is-one-quarter-desktop">
        <div class="field">
          <b-field label="Terminal">
            <b-select
              v-model="filtro.terminal"
              placeholder="Selecione o Destino*"
              expanded
              @input="buscar"
            >
              <option
                v-for="item in getDestinos"
                :key="item.id"
                :value="item.id"
              >
                {{ item.razaoSocial }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "FilterAgendamentos",
  props: {
    initialFilter: {
      placa: null,
      tipo: null,
      temDocumentoFiscal: null,
      terminal: null,
    },
  },
  data() {
    return {
      filtro: { ...this.initialFilter },
      terminais: [],
    };
  },
  methods: {
    buscar() {
      this.$emit("filtrar", this.filtro);
    },
  },
  mounted() {
    this.$http.get(`/empresas?page=0&tipo=TERMINAL`).then((response) => {
      this.terminais = response.data.content;
    });
  },
  computed: {
    getDestinos() {
      return this.terminais.map((destino) => {
        return {
          razaoSocial: destino.razaoSocial,
          id: destino.id,
        };
      });
    },
  },
});
</script>

<style></style>
